import { TranscriptorEncounterResponse } from '@/shared/api/transcriptor/transcriptorApi';

export const getEncounterTitle = (
  encounter: TranscriptorEncounterResponse,
): string => {
  const name = encounter.name?.trim();

  if (name) {
    return name;
  }

  const schemaName = encounter.schema_name?.trim();

  if (schemaName) {
    return schemaName;
  }

  return '—';
};
